import styled from 'styled-components';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';

export interface HighlightElement {
  $alignRows: boolean;
  $columnIndex: number;
  $rowsCount: number;
}

export const HighlightElementBase = styled.div.attrs<HighlightElement>(
  ({ $alignRows, $columnIndex, $rowsCount }) => ({
    // Используем inline-стили чтоб не приходилось создавать динамический класс под каждый highlight
    style: $alignRows
      ? {
          gridArea: `1 / ${$columnIndex} / ${$rowsCount} / ${$columnIndex + 1}`
        }
      : undefined,
    className: createReadableClass({
      component: 'highlight-element'
    })
  })
)`
  top: 0;
  left: 0;
  width: 100%;
  position: ${({ $alignRows }) => ($alignRows ? 'relative' : 'absolute')};
`;

export const HighlightContentBase = styled(Typography).attrs(
  ({
    theme: {
      highlight: { color }
    }
  }) => ({
    color,
    className: createReadableClass({
      component: 'highlight-element',
      element: 'content'
    }),
    textStyle: {
      fontSize: 10,
      lineHeight: '13px',
      fontWeight: 700,
      textTransform: 'uppercase'
    }
  })
)`
  z-index: 2;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({
    theme: {
      highlight: { backgroundColor }
    }
  }) => backgroundColor};
`;
